// Release Notes Docs
export const releaseNotesDocs = [
  {
    id: 'release_notes',
    label: 'Release Notes'
  }
];
